import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SearchFiltersComponent } from './search-filters.component'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { FiltersModule } from '../filters/filters.module'
import { SharedModule } from 'src/app/shared/shared.module'
import { ToggleModule } from '../toggle/toggle.module'

@NgModule({
  imports: [CommonModule, AnalyticsModule, FiltersModule, SharedModule, ToggleModule],
  declarations: [SearchFiltersComponent],
  exports: [SearchFiltersComponent]
})
export class SearchFiltersModule {}
